import React, { FunctionComponent, ReactNode } from 'react'
import { ExperimentProvider } from '@afterpaytouch/feature'
import { useAmplitudeWithEnduringEventProperties } from '../integrations/amplitude'
import { Experiment } from '../state/experiments/hooks'
import { triggerExperiment } from '../state/experiments/reducer'
import { useAppDispatch } from '../state/hooks'

const PortalExperiments = {
  EnabledPortalSignup: 'rocketship.enabled-portal-signup',
} as const

export type PortalExperimentName = keyof typeof PortalExperiments

interface PortalExperimentProviderProps {
  children: ReactNode
}

export const PortalExperimentProvider: FunctionComponent<PortalExperimentProviderProps> = ({ children }) => {
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  const dispatch = useAppDispatch()

  const reduxDispatch = (experiment: Experiment): void => {
    dispatch(triggerExperiment([experiment.name, experiment.value]))
  }

  const config = {
    monitoring: logEvent,
    experiments: PortalExperiments,
    reduxDispatch: reduxDispatch,
  }

  return <ExperimentProvider config={config}>{children}</ExperimentProvider>
}

export { PortalExperiments }
